import { Injectable } from '@angular/core';
import { HumanInterface } from '../engine/models/human.interface';

declare const Human: HumanInterface;

// Bytes (for Morphs)
enum uncompressedBytesPer {
  Positions = 4,
  Normals = 4,
}

enum compressedBytesPer {
  Positions = 2,
  Normals = 1,
}

@Injectable({
  providedIn: 'root',
})
export class MorphAssetMemoryService {
  constructor() {}

  /* Calculates morph sizes in BYTES
   * NOTE: The compressed size of the index array depends on the size of the array
   */
  getAsset(morphId: string) {
    return Human.assets.morphs.morphs[morphId];
  }

  // NOTE: Returns the array for a single morph target.
  getPositions(morphId: string) {
    return this.getAsset(morphId).morphGeometry._core.targets[0].positions;
  }

  // NOTE: Returns the array for a single morph target.
  getNormals(morphId: string) {
    return this.getAsset(morphId).morphGeometry._core.targets[0].normals;
  }

  // NOTE: Assumes that if one resource is compressed, then all of them are.
  isCompressed(morphId: string) {
    return this.getAsset(morphId).compressed;
  }

  calculatePositions(morphId, compressed) {
    const positions = this.getPositions(morphId);
    const bytesper = compressed ? compressedBytesPer.Positions : uncompressedBytesPer.Positions;
    return positions.length * bytesper;
  }

  calculateNormals(morphId, compressed) {
    const normals = this.getNormals(morphId);
    const bytesper = compressed ? compressedBytesPer.Normals : uncompressedBytesPer.Normals;
    return normals.length * bytesper;
  }

  calculateMorph(morphId, compressed) {
    return (
      this.calculatePositions(morphId, compressed) + this.calculateNormals(morphId, compressed)
    );
  }

  getVerts(morphId: string) {
    return this.getAsset(morphId).morphGeometry._core.targets[0].positions.length / 3;
  }

  getMorphMemory(morphId: string) {
    const asset = this.getAsset(morphId);
    const targ = asset.morphGeometry._core.targets[0];
    const targCount = asset.morphGeometry._core.targets.length;
    let memory = 0.0;
    memory += targCount * (targ.normalBuf.itemByteSize * targ.normalBuf.length);
    memory += targCount * (targ.vertexBuf.itemByteSize * targ.vertexBuf.length);
    return memory;
  }

  getStat(morphId: string) {
    return {
      id: morphId,
      verts: this.getVerts(morphId),
      memory: this.getMorphMemory(morphId),
    };
  }
}
